import { AspectRatio, Box, Image } from 'native-base';
import React from 'react';
import { SwiperProps } from 'react-native-swiper';

import Carousel from 'app/components/Carousel';

export type ImageCarouselProps = {
  images: ImageCarouselImage[];
  ratio?: number;
  _swiper?: SwiperProps;
};

export type ImageCarouselImage = {
  url: string;
  alt: string;
  caption?: string;
  credit?: string;
};

export default function ImageCarousel({ images = [], ratio = 5 / 3, _swiper }: ImageCarouselProps) {
  return (
    <Box bgColor="gray.200" style={{ aspectRatio: ratio }} testID="ImageCarousel">
      <Carousel {..._swiper}>
        {images.map(({ url, alt }, idx) => (
          <Image key={url || idx} alt={alt} h="full" source={{ uri: url }} w="full" />
        ))}
      </Carousel>
    </Box>
  );
}
